import React from "react";
import { useSelector, useDispatch } from "react-redux";
import toastr from "toastr";
import { LuFilterX } from "react-icons/lu";
import "toastr/build/toastr.min.css";
import { clearReportHubStatus, fetchReportHubStatus, getReport, getReportHubTaskStatus, getReportIDUpdate } from "../redux/project/projActions";
import { showLoader } from '../redux/ctrl/ctrlActions';
import { useEffect } from "react";
import { useState } from "react";
import { AgGridReact } from "ag-grid-react";
import StyledTooltip from '../shared/toolTip/StyledTooltip';
import { dateComparator, getDt, statusBar } from "../../utils";
import { useTranslation } from 'react-i18next';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import DialogActions from '@mui/material/DialogActions';
import { LuRefreshCcw } from "react-icons/lu";
import { getDtfrmt } from "../../utils";
import { FaAnglesLeft } from "react-icons/fa6";
import { TbViewportWide } from "react-icons/tb";
import { IoIosClose } from "react-icons/io";
import { agGridTrans } from "../translation/i18n";
import config from "../../utils/config";
// import StyledTooltip from "../shared/toolTip/StyledTooltip";

function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
    //  cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}
const ReportHub = (props) => {
  const prof = useSelector((state) => state.profile);
  const ctrl = useSelector((state) => state.ctrl);
  const [rowData, setRowData] = useState([]);
  const [rReport, setrReport] = useState(false);
  const [refreshIcon, setrRefreshIcon] = useState(false);
  const [gridApi, setGridApi] = useState(null);
  const [rowDataRI, setRowDataRI] = useState([]);
  const [reportInputExpand, setReportInputExpand] = useState(false);
  const [windowInfo, setWindowInfo] = useState(true);
  const [loadFirst, setloadFirst] = useState(true);
  const [pendingID, setPendingID] = useState([]);
  const { t, i18n } = useTranslation();
  const project = useSelector((state) => state.project);
  const selectedRows = props.selectedRows;
  const dispatch = useDispatch();

  const [reportClickEnabled, setReportClickEnabled] = useState(false);

  const reportHubStatus = project.reportHubStatus;

  const replaceCharactrs = (str) => {
    if (str) {
      let strFN = str.replace(/[&\/\\#,\-\ +()$~%.'":*?<>{}]/g, '_')
      return strFN;
    }
  }



  let lineItems = [
    // {
    // "thirdPosition": "firstItem",
    // "ForthPosition": "report",
    // "I_HEADER_ID": "",
    // "I_LINE_ID": null,
    // "I_PA_REFENCE_ID": "",
    // "I_DIV_ID": "",
    // "SizeCTA": ""
    // }
  ];

  let d = new Date();
  let mnth = d.getUTCMonth() + 1;
  let gtmnth = mnth.toString().length === 1 ? "0" + mnth.toString() : mnth.toString();
  let gtdate = d.getFullYear().toString() + gtmnth + d.getDate().toString();
  let gttime = d.getHours().toString() + d.getMinutes() + d.getSeconds() + d.getMilliseconds().toString().slice(1, 3);
  let unique_project_name = replaceCharactrs(ctrl.data.project_name) + "_" + gtdate + gttime;

  let getRepPL = {
    //headerData: {
    source: "project_workspace",
    email: prof.email,
    // mail: "yes",
    lang: "en_US",
    //  ConfigHeaderId: "",
    name_meta: {
      project_name: ctrl.data.project_name,
      package_name: ctrl.pkg.package_name,
    },
    // },

    items: { lineItems },

  };

  let tagWithoutRefID = [];
  let reportTags = [];

  let pkgDetail = {
    task_id: "",
    request_by: prof.email.toLowerCase(),
    project_name: ctrl.data.project_name,
    package_name: ctrl.pkg.package_name,
    revision: ctrl.pkg.active_revision,
    zipfilename: "",
    failure_desc: "",
    request_date: getDt(new Date()),
    state: "SUBMITTED",
    reportinput: reportTags,
  }





  let limitReport = 20;
  let fhRepStaPL = {
    package_id: ctrl.pkg.package_id,
    project_id: ctrl.pkg.project_id,
    revision: props?.revision?.value,
    request_by: prof.email.toLowerCase()
  }
  //new code
  const getReportClick = () => {
    lineItems = [];
    reportTags = [];
    tagWithoutRefID = [];

    if (!selectedRows || (selectedRows && selectedRows.length === 0)) {
      toastr.error(t('Please Select the Tag line'))
    }
    if (selectedRows && selectedRows.length > 0) {
      selectedRows.map((tags) => {
        if (tags.pur_pa_id || (tags.quote_hdr_id && tags.quote_line_id)) {
          let lineItemTemp = {
            //Config_Header_Id:"",
            //Config_Rev_Id: "",
            tag_number: tags.tag_number,
            header_id: tags.quote_hdr_id || "",
            line_id: tags.quote_line_id || "",
            sizing_id: tags.pur_pa_id || "",

            sizing_tool: !tags.pur_pa_id
              ? "DP-Flow"
              : tags.gen_technology_type.includes(" ")
                ? tags.gen_technology_type.replace(/\s+/g, "-")
                : tags.gen_technology_type,
            //I_DIV_ID: tags.division_code,
            //SizeCTA: tags.division_code,
          };
          // if (tags.gen_technology_type === "DP Level") {
          //   lineItemTemp.sizing_tool = "MSOLLPA";
          // }
          // if (tags.gen_technology_type === "DP Flow" && config.MSOL_DP_FLOW_PA_ACTIVE === 'Y') {
          //   lineItemTemp.sizing_tool = "MSOLDPFlowPA";
          // }
          // if (tags.gen_technology_type === "Flow" && config.MSOL_FLOW_PA_ACTIVE === 'Y' && tags.pur_pa_id.substring(0, 2) === "FL") {
          //   lineItemTemp.sizing_tool = "Flow";
          // }
          lineItems.push(lineItemTemp);

          let reportTagsTemp = {
            tag_id: tags.tag_id,
            tag_number: tags.tag_number,
            sizing_id: tags.pur_pa_id,
            pur_configurator_id: tags.pur_configurator_id,
          }
          reportTags.push(reportTagsTemp);

        } else {
          tagWithoutRefID.push(tags);
        }
      });
    }

    if (tagWithoutRefID.length > 0) {
      //toastr.error("Please Select Tag with PA Ref ID");
      toastr.error(t('Please select Sized or Configured Tag'));
    }
    if (tagWithoutRefID.length === 0 && lineItems.length > 0) {
      getRepPL.items = lineItems;
      console.log("getRepPL", getRepPL)
      pkgDetail.reportinput = reportTags;
      pkgDetail.revision = Number(props.revision.value);
      // dispatch(showLoader(true));
      dispatch(fetchReportHubStatus(fhRepStaPL));
      // console.log("fetch called")
      toastr.error(t('getReport API is Disabled for now'));
      // dispatch(getReport(getRepPL, pkgDetail));
    }
  }



  useEffect(() => {

    if (!reportClickEnabled) {
      setReportClickEnabled(true);
    }
    if (reportClickEnabled) {
      getReportClick();
    }


  }, [props.click])
  //console.log("reportHubStatus")

  useEffect(() => {
    if (project.reportHubTaskID.status === "SUCCESS") {
      toastr.success(t(project.reportHubTaskID.message));
    }
    if (project.reportHubTaskID.status === "FAILURE") {
      toastr.error(project.reportHubTaskID.message);
    }
    if (project.reportHubTaskID) {
      dispatch(getReportIDUpdate(""));
      dispatch(showLoader(false));
    }

  }, [project.reportHubTaskID])

  const closeViewStatus = () => {
    props.clickChild(false);
    setrRefreshIcon(false);
    setRowData([]);
    setWindowInfo(true);
    setloadFirst(true);
  }



  const statusClass = (params) => {
    if (params.value === "FAILURE") {
      return 'red-cell';
    } else if (params.value === "PENDING") {
      return 'orange-cell';
    }
    // else if(params.value === "SUBMITTED")
    //   {
    //     return 'blue-cell';
    //   } 
    //   else if(params.value === "Failed to Submit")
    //     {
    //       return 'red-cell';
    //     }
    else {
      return 'green-cell';
    }

  }

  const [colDefs, setColDefs] = useState([
    {
      headerName: '',
      minWidth: 60,
      maxWidth: 60,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    // {headerName:'Batch ID',field:'batch_id',filter: "agTextColumnFilter", minWidth: 130, resizable: true, },
    { headerName: t('Project Name'), field: "project_name", filter: "agTextColumnFilter", minWidth: 150, resizable: true, },
    { headerName: t('Package Name'), field: "package_name", filter: "agTextColumnFilter", minWidth: 150, resizable: true, },
    { headerName: t('Request Date'), field: "request_date", filter: "agTextColumnFilter", sortable: true, comparator: dateComparator, },
    { headerName: t('Delivery Status'), field: "state", filter: "agTextColumnFilter", minWidth: 150, cellClass: statusClass, },
    { headerName: t('Failure Description'), field: "failure_desc", filter: "agTextColumnFilter", minWidth: 170, resizable: true },
    { headerName: t('File Name'), field: "zipfilename", filter: "agTextColumnFilter", minWidth: 150, resizable: true, },
    { headerName: t('Report Input'), field: 'reportinput', width: 60, filter: true, resizable: false, minWidth: 130, cellRenderer: () => <TbViewportWide className="expandReport" onClick={openReportInput} /> },
    { headerName: t('Revision'), field: "revision", filter: "agTextColumnFilter", minWidth: 100, resizable: true, },
    { headerName: t('Task ID'), field: "task_id", filter: "agTextColumnFilter", minWidth: 200, resizable: true, },

  ]);

  const [colDefs2, setColDefs2] = useState([
    {
      headerName: '',
      minWidth: 60,
      maxWidth: 60,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { headerName: t('Tag Number'), field: "tag_number", filter: "agTextColumnFilter", minWidth: 200, resizable: true, },
    { headerName: t('PA Ref ID'), field: "sizing_id", filter: "agTextColumnFilter", minWidth: 200, resizable: true, },
    { headerName: t('Config Header ID'), field: "pur_configurator_id", filter: "agTextColumnFilter", minWidth: 200, resizable: true, },

  ]);

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    editable: false,
    sortingOrder: ["asc", "desc", " "],
    filterParams: {
      buttons: ["apply", "cancel"],
      closeOnApply: true,
    },
    menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],
  };


  useEffect(() => {
    if (reportHubStatus.length > 0) {
      reportHubStatus.sort((a, b) => new Date(b.request_date) - new Date(a.request_date));
      reportHubStatus.map((data) => {
        let dateValue = getDtfrmt(data.request_date)
        data.request_date = dateValue;
      })

      //let reportHubStatusReverse = reportHubStatus.sort((a, b) => new Date(b.request_date) - new Date(a.request_date)) 
      if (props.reportStatus) {
        setTimeout(() => {
          refreshReport();
          setRowData(reportHubStatus);
        }, 1000)
        // gridApi.refreshCells();
      }


    }
    // if (props.reportStatus && reportHubStatus.length === 0 ) {   
    if (props.reportStatus && reportHubStatus.length === 0 && project.phase !== "SUCCESS") {
      dispatch(showLoader(true));
      setloadFirst(false);
      // console.log("fhRepStaPL", fhRepStaPL)
      dispatch(fetchReportHubStatus(fhRepStaPL));
    }

    if (!props.reportStatus && reportHubStatus.length > 0) {
      dispatch(clearReportHubStatus());
      setPendingID([]);
    }
  }, [props.reportStatus, reportHubStatus])

  const refreshReportClicked = () => {
    if (refreshIcon) {
      setRowData([]);
      setrRefreshIcon(false);
      dispatch(clearReportHubStatus());
      setPendingID([]);
      refreshReport();
    }

  }

  const refreshReport = () => {
    setrReport(true);
    if (reportHubStatus) {
      for (let i = 0; i < reportHubStatus.length; i++) {
        if (reportHubStatus[i].state === 'SUBMITTED' || reportHubStatus[i].state === 'PENDING') {
          if (!pendingID.includes(reportHubStatus[i].task_id)) {
            pendingID.push(reportHubStatus[i].task_id);
            setPendingID(pendingID);
            toastr.info(t('getReportHubTaskStatus API disabled: '));
            // dispatch(getReportHubTaskStatus(reportHubStatus[i].task_id, reportHubStatus[i].state));
            break;
          }

        }
      }
    }
    setTimeout(() => {
      setrReport(false)
    }, 3000)

  }
  // clear filter 
  const clearFilters = () => {
    if (gridApi) {
      gridApi.setFilterModel(null);
    }
  };
  // clear filter
  const onGridReady = (params) => {
    setGridApi(params.api);
  }

  useEffect(() => {
    if (rowData.length > 0 && !props.reportStatus) {
      closeViewStatus();
    }
    if (rowData && gridApi) {
      const refreshCellDebounce = setTimeout(() => {
        gridApi.refreshCells();
      }, 2000)
      return () => {
        clearTimeout(refreshCellDebounce);
      }

    }
  }, [rowData])


  useEffect(() => {
    if (props.reportStatus) {
      const refreshIconDebounce = setTimeout(() => {
        if (project.phase === "INIT") {
          setrRefreshIcon(true);
        }
      }, 2000)
      return () => {
        clearTimeout(refreshIconDebounce);
      }

    }
  }, [project.phase])

  const onClickCell = (e) => {
    if (e.colDef.field === "reportinput") {
      setRowDataRI(e.data.reportinput);
    }
  }

  const openReportInput = () => {
    setReportInputExpand(true);
  }

  const closeReportInput = () => {
    setReportInputExpand(false);
    setRowDataRI([]);

  }
  const windowInfoClose = () => {
    setWindowInfo(false);
  }

  useEffect(() => {
    if (project.phase === "LOADING" && loadFirst && props.reportStatus) {
      dispatch(showLoader(true));
      setloadFirst(false);
    }
    if (project.phase === "SUCCESS" && !loadFirst && props.reportStatus) {
      setTimeout(() => {
        dispatch(showLoader(false));
      }, 1500)
    }
  }, [project.phase])

  return (
    <>

      <Dialog open={props.reportStatus} onClose={closeViewStatus} className="viewReportStatus-model muiForm-Modal" PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title">
        <DialogTitle className="model-title mb-0 text-align-center" >
          <div className='header-row'>


            <div id="draggable-dialog-title" className=''>
              {t('Report Request Status')}
              <StyledTooltip title={t('Refresh')} placement="bottom" disableInteractive>
                <span className={!refreshIcon ? 'refresh-report disabled' : 'refresh-report'} onClick={refreshReportClicked}>
                  <LuRefreshCcw className={rReport ? 'animatonSVG' : ''} />
                </span>
              </StyledTooltip>
            </div>
            {/* clear filter */}
            <StyledTooltip title={'Clear Filters'} placement="bottom" disableInteractive>
              <label>
                <LuFilterX
                  className="tag-grid-head-cntrl mx-2"
                  onClick={clearFilters}
                  style={{ cursor: "pointer" }}
                />
              </label>
            </StyledTooltip>
          </div>

        </DialogTitle>
        <DialogContent>
          <Grid container className="ag-theme-alpine marginRow muiForm mb-2 pt-3" spacing={1.4}>
            <Grid item md={12} xs={12}>
              <div style={{ height: windowInfo ? "58vh" : "65vh" }}>
                <AgGridReact
                  statusBar={statusBar}
                  defaultColDef={defaultColDef}
                  rowData={rowData}
                  localeText={agGridTrans[localStorage.getItem("lang")]}
                  onGridReady={onGridReady}
                  columnDefs={colDefs}
                  headerHeight={30}
                  //  rowSelection={'single'}
                  rowHeight={26}
                  onCellClicked={(e) => onClickCell(e)}

                ></AgGridReact>

              </div>
            </Grid>

            {rowData.length > 0 && windowInfo && <Grid item md={12} xs={12}>

              <div className="windowInfo">
                <b>{t('Note:')}  </b> {t('This is a Report Request status window there is no link to Report.')}

                {t('User should check their inbox for report.')}
                <span className="closeWindowInfo" onClick={windowInfoClose}> <IoIosClose /> </span>
              </div>
            </Grid>}
          </Grid>
        </DialogContent>
        <DialogActions className="model-actions" style={{ "paddingRight": "24px" }}>
          <button className="cnbtn btn cancel-btn" variant="outlined" onClick={closeViewStatus}>
            {t('Close')}
          </button>


        </DialogActions>
      </Dialog>


      <Dialog open={reportInputExpand} onClose={closeReportInput} className="viewReportInput-model muiForm-Modal" PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title">
        <DialogTitle className="model-title mb-0 text-align-center" >
          <div className='header-row'>


            <div id="draggable-dialog-title" className=''>{t('Report Input')}

            </div>
          </div>

        </DialogTitle>
        <DialogContent>
          <Grid container className="ag-theme-alpine marginRow muiForm mb-2 pt-3" spacing={1.4}>
            <Grid item md={12} xs={12}>
              <div style={{ height: "60vh" }}>
                <AgGridReact
                  statusBar={statusBar}
                  defaultColDef={defaultColDef}
                  rowData={rowDataRI}
                  localeText={agGridTrans[localStorage.getItem("lang")]}
                  onGridReady={onGridReady}
                  columnDefs={colDefs2}
                  headerHeight={30}
                  rowHeight={26}
                  onCellClicked={(e) => onClickCell(e)}
                ></AgGridReact>

              </div>
            </Grid>


          </Grid>
        </DialogContent>
        <DialogActions className="model-actions" style={{ "paddingRight": "24px" }}>
          <button className="cnbtn btn cancel-btn" variant="outlined" onClick={closeReportInput}>
            {t('Close')}
          </button>


        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReportHub;
